// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3xTP4","approved":"Status_approved__2HAcu","rejected":"Status_rejected__1Vr-1","expired":"Status_expired__3HKsl","label":"Status_label__8UaWn"};